import { FC, ReactElement } from 'react';

import { Picture } from '../../components';
import { AppRoute, appRoutes } from '../../entities/Routing/Routing';
import { useTrans } from '../../hooks';
import { LinkButton } from '../@buttons/LinkButton/LinkButton';

import './RegisterCallToAction.scss';

interface RegisterCallToActionProps {
    className?: string;
}

export const RegisterCallToAction: FC<RegisterCallToActionProps> = ({
    className = '',
}): ReactElement => {
    const trans = useTrans();

    const imageFormats = {
        original: {
            srcSet: '/mock/image/register-call-to-action-desktop.webp',
            type: 'image/webp',
            media: '(min-width: 1024px)',
        },
        large: {
            srcSet: '/mock/image/register-call-to-action-desktop.webp',
            type: 'image/webp',
            media: '(min-width: 768px)',
        },
        medium: {
            srcSet: '/mock/image/register-call-to-action-desktop.webp',
            type: 'image/webp',
            media: '(min-width: 480px)',
        },
        small: {
            srcSet: '/mock/image/register-call-to-action-mobile.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    };

    return (
        <div className={`register-call-to-action ${className}`}>
            <Picture
                src="/mock/image/register-call-to-action-mobile.webp"
                formats={imageFormats}
                className="register-call-to-action__picture"
                imageClassName="register-call-to-action__image"
            />

            <div className="register-call-to-action__content">
                <h2 className="register-call-to-action__heading">
                    {trans('compositions.registerCallToAction.heading')}
                </h2>

                <p className="register-call-to-action__text">
                    {trans('compositions.registerCallToAction.text')}
                </p>

                <LinkButton
                    to={trans(appRoutes[AppRoute.registration].path)}
                    text={trans('compositions.registerCallToAction.buttonLabel')}
                    className="register-call-to-action__button"
                />
            </div>
        </div>
    );
};
